import { RiskClass } from '../../shared/models/risk-class.enums'

/**
 * Model to manage rules related data.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class Rule {
    id: number;
    name: string;
    ruleText: string;
    ruleGroupId: number;
    ruleGroupName: string;
    riskClass: RiskClass;
}



// WEBPACK FOOTER //
// ./src/app/admin/rules/rule.model.ts